//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'maternal_info_detail',
        data (){
            return {
                memberDetailList:{
                    name:'',
                    group_name: '',
                    sex: '',
                    channel_name: '',
                    phone: '',
                    consult_time: '',
                    birthday: '',
                    address: '',
                    remark: '',
                    family_info: [],
                    nation: '',
                    birth_place: '',
                    height: '',
                    weight: '',
                    education: '',
                    job: '',
                    child_birth: '',
                    hospital: ''
                }
            }
        },
        methods:{
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '-' + m + '-' + d
            },
            //请求孕妇个人信息
            apiMemberDetail () {
                let params = {
                    token: this.$cookie.get('token'),
                    id: this.$route.query.id
                }
                console.info(params)
                Api.memberListApi.memberDetail(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        let data = res.data
                        //基本信息
                        this.memberDetailList.name = data.name
                        this.memberDetailList.group_name = data.group_name
                        this.memberDetailList.sex = data.sex == '1' ? '男' : '女'
                        this.memberDetailList.channel_name = data.channel_name
                        this.memberDetailList.phone = data.phone
                        this.memberDetailList.consult_time = this.formatDateTime(data.consult_time)
                        this.memberDetailList.birthday = this.formatDateTime(data.birthday)
                        this.memberDetailList.address = data.district_str +  data.address
                        this.memberDetailList.remark = data.remark
                        //家属信息
                        this.memberDetailList.family_info = data.family_info
                        //其他信息
                        this.memberDetailList.nation = data.nation
                        this.memberDetailList.birth_place = data.birth_place
                        this.memberDetailList.height = data.height
                        this.memberDetailList.weight = data.weight
                        this.memberDetailList.education = data.education
                        this.memberDetailList.job = data.job
                        //孕妇信息
                        this.memberDetailList.child_birth = this.formatDateTime(data.child_birth)
                        this.memberDetailList.hospital = data.hospital
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            edit(){
                this.$router.push({
                    path:'/edit_maternal_info',
                    
                    })
            }
        },
        created(){
            this.apiMemberDetail()
        } 
    }



// WEBPACK FOOTER //
// ./src/components/maternal_info_detail.vue